import { Component, OnInit, Output, EventEmitter, ViewChild, Input, HostListener } from '@angular/core';
import { Model } from 'src/app/entities/model';
import { IxellAPIService, IConstructeurV1, LoginData } from 'src/app/tools/api.service';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { HeaderService } from 'src/app/tools/header.service';
import { StorageService } from 'src/app/tools/storage.service';
import { LogInService } from '../../tools/login-service';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { StatsCBLogType } from '../globalColorbook/globalColorbook.component';

@Component({
    selector: 'vehicle',
    templateUrl: './vehicle.component.html',
    styleUrls: ['./vehicle.component.scss']
})

export class VehicleComponent implements OnInit {
    @ViewChild('slider') owlElement: CarouselComponent;
    @Output() modelOutput = new EventEmitter<Model>();
    @Output() manufacturerOut = new EventEmitter<string>();
    @Input() model: Model;
    @Input() manufacturer: string;
    @Output() statsLog = new EventEmitter<{ type: StatsCBLogType, value: string }>();

    filteredOptions: Observable<string[]>;
    modelLst: Model[] = [];
    modelLstToShow: Model[] = [];
    isDragging: boolean = false;
    mySlideImages: any[] = [];
    mySlideOptions: OwlOptions = {
        dots: false,
        nav: false,
        rewind: true,
        center: false,
        stagePadding: 2
    };

    manufacturersSub: any;
    modelSub: any;
    removeSerieSub: any;
    removeGammeSub: any;

    shownManufacturer: any[] = [];
    breakpoint: number;
    heightSize: string;
    allManufacturers: IConstructeurV1[] = [];

    login: string;
    password: string;
    colorbookLogInSub: any;
    autreMarque: any;
    isInitCarousel: boolean = false;

    Form = new UntypedFormGroup({
        manufacturerCtrl: new UntypedFormControl('')
    });

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    constructor(private headerService: HeaderService, private apiService: IxellAPIService, private storage: StorageService, private logInService: LogInService, private route: ActivatedRoute) { }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnInit() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("/*----------------------------------------------------------------------------------------------------*/");
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : ngoninit");

        this.login = this.route.snapshot.paramMap.get('login');
        if (!this.login) this.login = this.route.snapshot.queryParams['login'];
        if (this.login) {
            this.password = this.route.snapshot.paramMap.get('pwd');
            if (!this.password) this.password = this.route.snapshot.queryParams['pwd'];
            if (this.password) {
                let data: LoginData = new LoginData();
                data.login = this.login;
                data.password = this.password;
                this.colorbookLogInSub = this.apiService.logInColorBook(data).subscribe(async data => {
                    this.logInService.parseLogIn(data);
                    await this.delay(50);
                    //this.removeSerieSub = this.headerService.currentRemoveSerie.subscribe(remove => {
                    //  if (remove) {
                    //    setTimeout(() => {
                    //      this.modelManage(this.manufacturer);
                    //    }, 50);
                    //  }
                    //});
                    //this.removeGammeSub = this.headerService.currentRemoveGamme.subscribe(remove => {
                    //  if (remove) {
                    //    setTimeout(() => {
                    //      this.modelManage(this.manufacturer);
                    //    }, 50);
                    //  }
                    //});
                    this.initColorBook();
                });
            }
        }
        else {
            //this.removeSerieSub = this.headerService.currentRemoveSerie.subscribe(remove => {
            //  if (remove) {
            //    setTimeout(() => {
            //      this.modelManage(this.manufacturer);
            //    }, 50);
            //  }
            //});
            //this.removeGammeSub = this.headerService.currentRemoveGamme.subscribe(remove => {
            //  if (remove) {
            //    setTimeout(() => {
            //      this.modelManage(this.manufacturer);
            //    }, 50);
            //  }
            //});
            this.initColorBook();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    private _filter(name: string) {
        return this.shownManufacturer.filter(option => option.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    initColorBook() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : initColorBook");
        this.headerService.changeCanBack(true);
        window.onpopstate = function () {
        };
        //if (this.manufacturer) {
        this.removeSerieSub = this.headerService.currentRemoveSerie.subscribe(remove => {
            if (remove) {
                setTimeout(() => {
                    this.modelManage(this.manufacturer);
                }, 50);
            }
        });
        this.removeGammeSub = this.headerService.currentRemoveGamme.subscribe(remove => {
            if (remove) {
                setTimeout(() => {
                    this.modelManage(this.manufacturer);
                }, 50);
            }
        });
        //}

        this.manufacturersSub = this.apiService.getAllManufacturers().subscribe(data => {
            this.allManufacturers = data;
            let index: number = 3;
            data.forEach(el => {
                if (el.libelle.toLowerCase() == "alpine")
                    this.mySlideImages.splice(0, 0, { src: "assets/manufacturer/" + el.logo, name: el.libelle, position: 0 });
                else if (el.libelle.toLowerCase() == "renault")
                    this.mySlideImages.splice(1, 0, { src: "assets/manufacturer/" + el.logo, name: el.libelle, position: 1 });
                else if (el.libelle.toLowerCase() == "dacia")
                    this.mySlideImages.splice(1, 0, { src: "assets/manufacturer/" + el.logo, name: el.libelle, position: 2 });
                else {
                    if (el.constructeur_id == 0)
                        this.mySlideImages.push({ src: "assets/manufacturer/" + el.libelle.toLowerCase() + ".png", name: el.libelle, position: index });
                    else
                        this.mySlideImages.push({ src: "assets/manufacturer/" + el.logo, name: el.libelle, position: index });
                    index += 1;
                }
            });
            this.shownManufacturer = this.mySlideImages;
            this.isInitCarousel = true;
            if (this.manufacturersSub != null) this.manufacturersSub.unsubscribe();

            setTimeout(() => {
                this.refreshCarouselItemsPerScreen();

                let manu = this.storage.get("manufacturer");
                if (manu) {
                    this.manufacturer = manu;
                    this.mySlideImages.forEach(element => {
                        if (element.name.toLowerCase() == this.manufacturer.toLowerCase()) {
                            document.getElementById(element.name).click();
                            this.owlElement.to('slide' + element.position);
                        }
                    });
                }
            }, 200);

            this.filteredOptions = this.Form.controls.manufacturerCtrl.valueChanges.pipe(
                startWith(""),
                map(value => this._filter(value))
            );
        }, error => {
            if (this.manufacturersSub != null) this.manufacturersSub.unsubscribe();
            console.log(error);
        });

        if (window.innerWidth <= 576)
            this.breakpoint = 2;
        else
            this.breakpoint = Math.round(window.innerWidth / 288);

        this.heightSize = (window.innerWidth <= 600) ? "4:3" : "6:1";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    search(query: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : search");

        let res = [];
        for (let a of this.mySlideImages) {
            if (a.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                res.push(a)
            }
        }
        this.shownManufacturer = res;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    showDropDown() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : shownDropDown");

        (document.getElementsByClassName("ddManufacturer")[0] as HTMLElement).style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    DropdownSelected(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : DropdownSelected");

        document.getElementById(event.option.value).click();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    displayModels(event: any, name: any, index: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : displayModels");
        if (name != this.manufacturer) {
            this.storage.remove("serie");
            this.storage.remove("gamme");
        }

        const realTimeItemCount = (this.owlElement as any).carouselService.settings.items;
        const lowDisplayIndex = Math.max(0, index - Math.ceil(realTimeItemCount / 2) + 1);
        const highDisplayIndex = this.mySlideImages.length - realTimeItemCount;
        this.owlElement.to('slide' + Math.min(lowDisplayIndex, highDisplayIndex));
        if (document.getElementsByClassName("owl-stage").length > 0) {
            for (var _i = 0; _i < document.getElementsByClassName("owl-stage")[0].children.length; _i++) {
                let img = (document.getElementsByClassName("owl-stage")[0] as HTMLElement).children[_i].firstElementChild.firstElementChild.firstElementChild;
                if (img !== null)
                    img.className = "logo sizeImg";
            }
        }

        if (event && event.currentTarget) {
            event.currentTarget.className += " selected"
            event.currentTarget.parentElement.parentElement.parentElement.className += " center";
        }
        this.modelManage(name);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    modelManage(name: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : modelManage");

        this.modelLstToShow = [];
        if (name) {
            this.manufacturer = name.toLowerCase();
            if (name.toLowerCase() != "renault" && name.toLowerCase() != "dacia" && name.toLowerCase() != "alpine")
                this.heightSize = "6:1";
            else
                this.heightSize = "4:3";
        }
        let index2 = this.allManufacturers.findIndex(el => el.libelle == name);
        let modPrev = this.storage.get("model");
        let gammePrev = this.storage.get("gamme");
        let seriePrev = this.storage.get("serie");

        if (this.allManufacturers && index2 != -1) {
            this.modelSub = this.apiService.getModelsByManufacturer(this.allManufacturers[index2].constructeur_id, this.allManufacturers[index2].libelle).subscribe(data => {
                if (gammePrev)
                    this.statsLog.emit({ type: StatsCBLogType.Gamme, value: gammePrev });

                if (seriePrev)
                    this.statsLog.emit({ type: StatsCBLogType.Serie, value: seriePrev });

                if (modPrev)
                    this.statsLog.emit({ type: StatsCBLogType.Libelle, value: modPrev });

                this.modelLst = [];
                data.forEach(element => {
                    let mod: Model = new Model();
                    if (this.manufacturer.toLowerCase() == "renault" || this.manufacturer.toLowerCase() == "dacia" || this.manufacturer.toLowerCase() == "alpine")
                        mod.picture = "assets/" + name + "/" + element.libelle.replace("é", "e").toUpperCase() + ".png";
                    mod.id = element.modele_id;
                    mod.name = element.libelle;
                    mod.gamme = element.gamme;
                    mod.serie = element.serie;
                    mod.dateDeb = element.dateDeb;
                    mod.dateFin = element.dateFin;
                    if (mod.gamme)
                        mod.isGamme = true;

                    if (modPrev) {
                        if (modPrev == mod.name) {
                            mod.isPrev = true;
                            this.SelectModel(mod);
                        }
                    }
                    else {
                        if (seriePrev) {
                            if (seriePrev == mod.serie) {
                                mod.isSerie = true;
                                mod.isGamme = false;
                                this.modelLst.push(mod);
                            }
                        }
                        else {
                            if (gammePrev) {
                                if (gammePrev == mod.gamme) {
                                    mod.isGamme = true;
                                    this.modelLst.push(mod);
                                }
                            }
                            else {
                                this.modelLst.push(mod);
                            }
                        }
                    }
                });

                this.modelLst.forEach(
                    element => {
                        let mod: Model = new Model();
                        mod.dateDeb = element.dateDeb;
                        mod.dateFin = element.dateFin;
                        mod.id = element.id;
                        mod.isVisible = element.isVisible;
                        if (gammePrev && !seriePrev) {
                            mod.name = element.name;
                            mod.picture = "assets/" + name.toUpperCase() + "/" + element.name.replace("é", "e").toUpperCase() + ".png";
                            mod.isGamme = element.isGamme;
                            mod.gamme = element.gamme;
                            mod.serie = element.serie;
                            if (!mod.serie) {
                                mod.serie = mod.name;
                                mod.isGamme = false;
                            }
                            else {
                                mod.isGamme = false;
                                mod.isSerie = true;
                            }
                            if (this.modelLstToShow.findIndex(elem => elem.name == mod.serie) == -1)
                                this.modelLstToShow.push(mod);
                        }
                        else {
                            if (seriePrev) {
                                mod.name = element.name;
                                mod.picture = "assets/" + name.toUpperCase() + "/" + element.name.replace("é", "e").toUpperCase() + ".png";
                                mod.isGamme = element.isGamme;
                                mod.gamme = element.gamme;
                                mod.serie = element.serie;
                                if (!mod.serie) {
                                    mod.serie = mod.name;
                                    mod.isGamme = false;
                                }
                                else {
                                    mod.isGamme = false;
                                    mod.isSerie = false;
                                }
                                if (this.modelLstToShow.findIndex(elem => elem.name == mod.name) == -1)
                                    this.modelLstToShow.push(mod);
                            }
                            else {
                                if (element.isGamme) {
                                    mod.name = element.gamme;
                                    mod.picture = "assets/" + name.toUpperCase() + "/" + element.gamme.replace("é", "e").toUpperCase() + "_GAMME.png";
                                    mod.isGamme = true;
                                    mod.gamme = element.gamme;
                                    if (this.modelLstToShow.findIndex(elem => elem.gamme == mod.gamme) == -1)
                                        this.modelLstToShow.push(mod);
                                }
                                else {
                                    if (element.isSerie) {
                                        mod.name = element.name;
                                        mod.picture = "assets/" + name.toUpperCase() + "/" + element.name.replace("é", "e").toUpperCase() + ".png";
                                        mod.isSerie = false;
                                        mod.isGamme = false;
                                        if (this.modelLstToShow.findIndex(elem => elem.serie == mod.name) == -1)
                                            this.modelLstToShow.push(mod);
                                    }
                                    else
                                        this.modelLstToShow.push(element);
                                }
                            }
                        }

                    }
                );
                if (this.modelSub != null) this.modelSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.modelSub != null) this.modelSub.unsubscribe();
            });
            this.manufacturer = name;
            document.getElementsByClassName("models")[0].scrollTop = 0;
        }

        //this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    onResize(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : onResize");

        if (event.target.innerWidth <= 576)
            this.breakpoint = 2;
        else
            this.breakpoint = Math.round(event.target.innerWidth / 288);

        if (this.manufacturer) {
            if (this.manufacturer.toLowerCase() == "renault" || this.manufacturer.toLowerCase() == "dacia")
                this.heightSize = "4:3";
            else
                this.heightSize = "6:1";
        }

        this.refreshCarouselItemsPerScreen();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    refreshCarouselItemsPerScreen() {
        const slider = document.getElementById('slider') as HTMLElement;
        if (slider === null)
            return;

        const imgs = slider.getElementsByClassName('sizeImg') as HTMLCollectionOf<HTMLImageElement>;
        if (imgs.length > 0) {
            this.owlElement.carouselWindowWidth = slider.offsetWidth;
            this.mySlideOptions = { ...this.mySlideOptions, items: Math.floor(slider.offsetWidth / imgs[0].offsetWidth) };
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnDestroy(): void {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : ngOnDestroy");

        if (this.manufacturersSub != null) this.manufacturersSub.unsubscribe();
        if (this.modelSub != null) this.modelSub.unsubscribe();
        if (this.removeGammeSub != null) this.removeGammeSub.unsubscribe();
        if (this.removeSerieSub != null) this.removeSerieSub.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    SelectModel(model: Model) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : SelectModel");
        ///*----------------------------------------------------------------------------------------------------*/console.log("model : ", model);

        let gammePrev = this.storage.get("gamme");
        let seriePrev = this.storage.get("serie");

        if (model.isPrev) {
            this.model = model;
            this.modelLst.forEach(m => m.selected = false);
            this.model.selected = true;
            this.modelOutput.emit(this.model);
            this.manufacturerOut.emit(this.manufacturer);

            this.storage.set("manufacturer", this.manufacturer);
            this.storage.set("model", this.model.name);
        }
        else {
            if (model.isSerie) {

                this.storage.set("serie", model.name);
                this.modelLstToShow = [];
                this.modelLst.forEach(element => {
                    if (element.serie == model.name) {
                        element.isGamme = false;
                        element.isSerie = false;
                        this.modelLstToShow.push(element);
                    }
                });

                this.statsLog.emit({ type: StatsCBLogType.Serie, value: model.name });
            }
            else {
                if (model.isGamme) {
                    this.modelLstToShow = [];
                    this.modelLst.forEach(element => {
                        if (element.gamme == model.name) {
                            let mod: Model = new Model();
                            mod.dateDeb = element.dateDeb;
                            mod.dateFin = element.dateFin;
                            if (gammePrev) {
                                if (seriePrev) {
                                    if (this.modelLstToShow.findIndex(elem => elem.name == seriePrev) == -1)
                                        this.modelLstToShow.push(element);
                                }
                                else {
                                    if (this.modelLstToShow.findIndex(elem => elem.name == gammePrev) == -1)
                                        this.modelLstToShow.push(element);
                                }
                            }
                            else {
                                this.storage.set("gamme", model.name);
                                if (element.serie) {
                                    mod.name = element.serie;
                                    mod.picture = "assets/" + this.manufacturer.toUpperCase() + "/" + mod.name.replace("é", "e").toUpperCase() + ".png";
                                    mod.isGamme = false;
                                    mod.isSerie = true;
                                    mod.id = element.id;
                                    if (this.modelLstToShow.findIndex(elem => elem.name == mod.name) == -1)
                                        this.modelLstToShow.push(mod);
                                }
                                else {
                                    element.isGamme = false;
                                    this.modelLstToShow.push(element);
                                }
                            }
                        }
                    });

                    this.statsLog.emit({ type: StatsCBLogType.Gamme, value: model.name });
                }
                else {
                    this.model = model;
                    this.modelLst.forEach(m => m.selected = false);
                    this.model.selected = true;
                    this.modelOutput.emit(this.model);
                    this.manufacturerOut.emit(this.manufacturer);
                    this.storage.set("manufacturer", this.manufacturer);
                    this.storage.set("model", this.model.name);

                    this.statsLog.emit({ type: StatsCBLogType.Libelle, value: model.name });
                }
            }
        }
        //this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    key(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("vehicle : key");
        this.mySlideImages.forEach(element => {
            let name: string;
            name = element.name;
            if (name.toLowerCase().startsWith(event.key))
                this.owlElement.to('slide' + element.position);
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    drag(event: any) {
    }
}
